
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, class_type, record_type, list_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { InventoryKind, InventoryStateDefinitionModule_systemDefinition, InventoryBaseState, InventoryBaseState__get_Key, InventoryStatesDto_$reflection, InventoryStateDefinition_$reflection } from "../../Shared/InventoryStates.js";
import { FormState__getValidation, StorageId__get_unwrap, FormState__setValidationResponse_5219762A, FormState__startLoading, ToolId__get_unwrap, RequestedValue$1, FormState_get_empty, TokenDataDto_$reflection, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { ToolTypes_$reflection } from "../../Shared/Tool.js";
import { MultiStateUpdateDto, MultiStateUpdateDto_$reflection } from "../../Shared/MultiOperation.js";
import { tryFind as tryFind_1, exists, fold, length, toArray as toArray_1, tryPick, choose, collect, append as append_1, contains, ofArray, filter, map, singleton as singleton_1, empty, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { FSharpMap__get_IsEmpty, toList as toList_1, tryFind, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { safeHash, createObj, stringHash, equals, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { dateLabel, DescriptionHint, selectable as selectable_1, name as name_3, resolve } from "../../InventoryStates/Display.js";
import { Operators_IsNull } from "../../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import { unwrap, bind, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toISOString } from "../../Common.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { ofToolState, ofToolWithQuantityState, ofSetState } from "../../Shared/InventoryStateMapping.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { InvalidTextValue } from "../../Components/Text.js";
import { Helper_unitToTranslationKey } from "../../Shared/Consumable.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InfiniteTable } from "../Table/InfiniteTable.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { TableControlElement$1, TableControl$1 } from "../Table/Table.js";
import { TabsMenu } from "../TabsMenu.js";
import { List_distinctBy, List_distinct } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { Select } from "../../Components/Select.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { Button } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiUpdateStateModal.TableElementType", [], TableElementType, () => [[], [], [], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, Manufacturer, Model, Name, AdditionalName, InventoryNumber, Quantity, Type, Unit, SelectedStorageId, Storage, StorageSpace, CurrentState, AvailableStorageIds) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.Quantity = Quantity;
        this.Type = Type;
        this.Unit = Unit;
        this.SelectedStorageId = SelectedStorageId;
        this.Storage = Storage;
        this.StorageSpace = StorageSpace;
        this.CurrentState = CurrentState;
        this.AvailableStorageIds = AvailableStorageIds;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiUpdateStateModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["Quantity", option_type(float64_type)], ["Type", TableElementType_$reflection()], ["Unit", string_type], ["SelectedStorageId", option_type(string_type)], ["Storage", string_type], ["StorageSpace", string_type], ["CurrentState", InventoryStateDefinition_$reflection()], ["AvailableStorageIds", list_type(string_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetStateDate", "SetComment", "SetTarget", "StatesFetched", "Save", "AddElement", "RemoveElement", "InitTableElements", "StateUpdateResponse", "SetsFetched", "ToolsFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiUpdateStateModal.Msg", [], Msg, () => [[["Item", option_type(class_type("System.DateTime"))]], [["Item", string_type]], [["Item", InventoryStateDefinition_$reflection()]], [["Item", InventoryStatesDto_$reflection()]], [], [["ids", list_type(string_type)]], [["ids", list_type(string_type)]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, Sets, Tools, TableElements, RemovedElements, Dto, Target, SelectedStateDate, UserData, Definitions, StateKeys) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Sets = Sets;
        this.Tools = Tools;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.Dto = Dto;
        this.Target = Target;
        this.SelectedStateDate = SelectedStateDate;
        this.UserData = UserData;
        this.Definitions = Definitions;
        this.StateKeys = StateKeys;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiUpdateStateModal.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["Dto", MultiStateUpdateDto_$reflection()], ["Target", option_type(InventoryStateDefinition_$reflection())], ["SelectedStateDate", option_type(class_type("System.DateTime"))], ["UserData", TokenDataDto_$reflection()], ["Definitions", RequestedValue$1_$reflection(list_type(InventoryStateDefinition_$reflection()))], ["StateKeys", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]]);
}

function init(successCallback, onClose, userData, toolProps) {
    return [new State(FormState_get_empty(), successCallback, onClose, isEmpty(toolProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(toolProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), empty(), empty(), new MultiStateUpdateDto(empty(), empty(), empty(), InventoryBaseState__get_Key(new InventoryBaseState(0, [])), undefined, ""), undefined, undefined, userData, new RequestedValue$1(0, []), ofList(toolProps.StateKeys, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })), Cmd_batch(toList(delay(() => append(singleton(Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), InventoryStatesDto_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/inventory-states", (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(11, [Item_1])))), delay(() => append(!isEmpty(toolProps.SetIds) ? singleton(getSelectedSets(toolProps.SetIds, (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(11, [Item_3])))) : empty_1(), delay(() => (!isEmpty(toolProps.ToolIds) ? singleton(Cmd_getSelectedTools(map(ToolId__get_unwrap, toolProps.ToolIds), (Item_4) => (new Msg(10, [Item_4])), (Item_5) => (new Msg(11, [Item_5])))) : empty_1()))))))))];
}

function currentStateOf(state, definitions, id, stateKey, baseState) {
    return resolve(definitions, (Operators_IsNull(stateKey) ? true : (stateKey === "")) ? defaultArg(tryFind(id, state.StateKeys), InventoryBaseState__get_Key(baseState)) : stateKey, baseState);
}

function update(msg, state) {
    let bind$0040;
    switch (msg.tag) {
        case 1:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, (bind$0040 = state.Dto, new MultiStateUpdateDto(bind$0040.SetIds, bind$0040.ToolIds, bind$0040.ToolWithQuantityIds, bind$0040.StateKey, bind$0040.StateDate, msg.fields[0])), state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_none()];
        case 2:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, msg.fields[0], state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_none()];
        case 3:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, new RequestedValue$1(1, [msg.fields[0].States]), state.StateKeys), singleton_1((dispatch) => {
                dispatch(new Msg(7, []));
            })];
        case 4: {
            const target = defaultArg(state.Target, InventoryStateDefinitionModule_systemDefinition(new InventoryBaseState(0, [])));
            let stateDateString;
            const matchValue = target.BaseState;
            switch (matchValue.tag) {
                case 1:
                case 3:
                case 2: {
                    stateDateString = map_1(toISOString, state.SelectedStateDate);
                    break;
                }
                default:
                    stateDateString = undefined;
            }
            let updatedDto;
            const ToolIds = map((_arg) => _arg.ElementId, filter((element) => equals(element.Type, new TableElementType(0, [])), state.TableElements));
            updatedDto = (new MultiStateUpdateDto(map((_arg_1) => _arg_1.ElementId, filter((element_1) => equals(element_1.Type, new TableElementType(3, [])), state.TableElements)), ToolIds, map((_arg_2) => _arg_2.ElementId, filter((element_2) => equals(element_2.Type, new TableElementType(1, [])), state.TableElements)), target.Key, stateDateString, state.Dto.Comment));
            return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/multi-operations/state", toString(0, Auto_generateBoxedEncoder_437914C6(MultiStateUpdateDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(11, [Item_1])))];
        }
        case 8: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0]), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_batch(ofArray([Cmd_ofEffect((_arg_3) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_4) => {
                    state.OnClose();
                })]))];
            }
        }
        case 5: {
            const addedElements = msg.fields[0];
            const selectedElement = filter((tableElement) => contains(tableElement.Id, addedElements, {
                Equals: (x_1, y) => (x_1 === y),
                GetHashCode: (x_1) => (stringHash(x_1) | 0),
            }), state.RemovedElements);
            const updatedRemovedElements = filter((tableElement_1) => !contains(tableElement_1.Id, addedElements, {
                Equals: (x_2, y_1) => (x_2 === y_1),
                GetHashCode: (x_2) => (stringHash(x_2) | 0),
            }), state.RemovedElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, append_1(selectedElement, state.TableElements), updatedRemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_none()];
        }
        case 6: {
            const removedElements = msg.fields[0];
            const selectedElement_1 = filter((tableElement_2) => contains(tableElement_2.Id, removedElements, {
                Equals: (x_3, y_2) => (x_3 === y_2),
                GetHashCode: (x_3) => (stringHash(x_3) | 0),
            }), state.TableElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, filter((tableElement_3) => !contains(tableElement_3.Id, removedElements, {
                Equals: (x_4, y_3) => (x_4 === y_3),
                GetHashCode: (x_4) => (stringHash(x_4) | 0),
            }), state.TableElements), append_1(selectedElement_1, state.RemovedElements), state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_none()];
        }
        case 9:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(7, []));
            })];
        case 10:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), singleton_1((dispatch_2) => {
                dispatch_2(new Msg(7, []));
            })];
        case 7: {
            const matchValue_1 = state.Tools;
            const matchValue_2 = state.Sets;
            const matchValue_3 = state.Definitions;
            let matchResult, definitions, sets, tools;
            if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_3.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                definitions = matchValue_3.fields[0];
                sets = matchValue_2.fields[0];
                tools = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    const setElements = map((set$) => (new TableElement(newGuid(), set$.Id, set$.MasterData.Manufacturer, set$.MasterData.Model, set$.MasterData.Name, "", set$.MasterData.InventoryNumber, undefined, new TableElementType(3, []), "piece", set$.LocationInformation.StorageId, set$.LocationInformation.StorageName, set$.LocationInformation.StorageSpace, currentStateOf(state, definitions, set$.Id, set$.StateKey, ofSetState(set$.State)), empty())), sets);
                    const setAssignedToolIds = collect((x_5) => x_5, map((set$_1) => map((_arg_5) => _arg_5.ToolId, set$_1.AssignedTools), sets));
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, append_1(setElements, choose((tool) => {
                        if (tool.tag === 1) {
                            const tool_2 = tool.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_2.Id), tool_2.Manufacturer, tool_2.Model, tool_2.DisplayName, "", tool_2.InventoryNumber, undefined, new TableElementType(1, []), "piece", undefined, "", "", currentStateOf(state, definitions, ToolId__get_unwrap(tool_2.Id), "", ofToolWithQuantityState(tool_2.State)), empty());
                        }
                        else {
                            const tool_1 = tool.fields[0];
                            if (contains(ToolId__get_unwrap(tool_1.Id), setAssignedToolIds, {
                                Equals: (x_6, y_4) => (x_6 === y_4),
                                GetHashCode: (x_6) => (stringHash(x_6) | 0),
                            })) {
                                return undefined;
                            }
                            else {
                                return new TableElement(newGuid(), ToolId__get_unwrap(tool_1.Id), tool_1.Manufacturer, tool_1.Model, tool_1.DisplayName, "", tool_1.InventoryNumber, undefined, new TableElementType(0, []), "piece", StorageId__get_unwrap(tool_1.StorageId), "", tool_1.StorageSpace, currentStateOf(state, definitions, ToolId__get_unwrap(tool_1.Id), "", ofToolState(tool_1.State)), empty());
                            }
                        }
                    }, tools)), state.RemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_none()];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 11:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.Target, state.SelectedStateDate, state.UserData, state.Definitions, state.StateKeys), Cmd_errorToast("general.a_error_occured")];
        default:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Sets, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.Target, msg.fields[0], state.UserData, state.Definitions, state.StateKeys), Cmd_none()];
    }
}

function elementValidation(translate, formState, elementId) {
    return tryPick((tupledArg) => {
        if (tupledArg[0].startsWith(concat(elementId, ..."-"))) {
            return translate(tupledArg[1]);
        }
        else {
            return undefined;
        }
    }, toList_1(formState.Validations));
}

function Table(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const columnDefinition = toArray(delay(() => append(!FSharpMap__get_IsEmpty(props.FormState.Validations) ? singleton(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        const matchValue = elementValidation(t, props.FormState, row.ElementId);
        if (matchValue == null) {
            return new CellContent(0, [""]);
        }
        else {
            const value = matchValue;
            return new CellContent(2, [createElement(InvalidTextValue, {
                TestId: concat(row.Id, ..."-validation-message"),
                Text: value,
            })]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_2) => (new CellContent(0, [row_2.Model])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_3) => (new CellContent(0, [row_3.Name])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_4) => (new CellContent(0, [row_4.InventoryNumber])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("state", "", t("general.state"), (row_5) => (new CellContent(0, [name_3(t, row_5.CurrentState)])), "none", "text")), delay(() => singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (row_6) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_6.Unit))])), "none", "text"))))))))))))))));
    const elementTable = (tableKey, rows, onSelected) => {
        let elems, TableRows, Options;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "basis-[36rem]", "min-h-[36rem]", "overflow-hidden"])], (elems = [createElement(InfiniteTable, (TableRows = toArray_1(rows), (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "multiRow",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        }, {
            ColumnDefinitions: columnDefinition,
            Controls: singleton_1(new TableControlElement$1(0, [new TableControl$1(t("general.remove"), Recycle_Bin_1(), props.FormState.IsLoading ? undefined : ((rows_1) => {
                props.Dispatch(onSelected(map((_arg) => _arg.Id, rows_1)));
            }), true, false, "tools-dialog-toolreservation-dialog-remove-button")])),
            Options: Options,
            TableKey: tableKey,
            TableRows: TableRows,
        })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "flex", "flex-col", "flex-1"])], (elems_2 = toList(delay(() => {
        let elems_1, arg_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems_1 = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "multi-modal-tab-elements",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: (arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, patternInput[1].t("assign_multiple_tools_dialog.removed_elements", arg_1)),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "multi-modal-tab-removed-elements",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (props.IsAddedElementTabVisible ? singleton(elementTable("multi-update-state-elements", props.TableElements, (ids) => (new Msg(6, [ids])))) : singleton(elementTable("multi-update-state-removed-elements", props.RemovedElements, (ids_1) => (new Msg(5, [ids_1])))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function requiredKinds(elements) {
    const kinds = List_distinct(map((element) => {
        const matchValue = element.Type;
        switch (matchValue.tag) {
            case 3:
                return new InventoryKind(1, []);
            case 1:
                return new InventoryKind(2, []);
            case 2:
                return new InventoryKind(3, []);
            default:
                return new InventoryKind(0, []);
        }
    }, elements), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
    const matchValue_1 = filter((kind) => !equals(kind, new InventoryKind(2, [])), kinds);
    if (isEmpty(matchValue_1)) {
        return kinds;
    }
    else {
        return matchValue_1;
    }
}

function Form(props) {
    let list_4, elems_1;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const stateOptions = map((definition_1) => ({
        label: name_3(t, definition_1),
        value: definition_1,
    }), (list_4 = map((kind) => selectable_1(props.AccountSettings, kind, props.Definitions), requiredKinds(props.TableElements)), fold((candidates, selectable) => filter((candidate) => exists((definition) => (definition.Key === candidate.Key), selectable), candidates), List_distinctBy((_arg) => _arg.Key, append_1(selectable_1(props.AccountSettings, new InventoryKind(0, []), props.Definitions), append_1(selectable_1(props.AccountSettings, new InventoryKind(1, []), props.Definitions), selectable_1(props.AccountSettings, new InventoryKind(2, []), props.Definitions))), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), list_4)));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_1 = toList(delay(() => {
        let Label, Value;
        return append(singleton(createElement(Select, (Label = t("multi_operation.change_state.new_state"), (Value = bind((target) => tryFind_1((option_2) => (option_2.value.Key === target.Key), stateOptions), props.Target), {
            ComponentState: componentState,
            IsClearable: false,
            Label: unwrap(Label),
            NoOptionsMessage: "",
            OnChange: (option) => {
                if (option == null) {
                }
                else {
                    props.Dispatch(new Msg(2, [option.value]));
                }
            },
            Options: stateOptions,
            PlaceholderKey: "",
            TestId: "switch-storage-dialog-storage-target-test-id",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "storage")),
            Value: unwrap(Value),
        })))), delay(() => {
            let matchValue;
            return append((matchValue = props.Target, (matchValue == null) ? (empty_1()) : singleton(createElement(DescriptionHint, {
                Definition: matchValue,
            }))), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = bind((definition_2) => dateLabel(t, true, definition_2), props.Target), (matchValue_1 != null) ? singleton(createElement(DatePicker, {
                    ComponentState: componentState,
                    IsClearable: true,
                    Label: matchValue_1,
                    OnChange: (arg) => {
                        props.Dispatch(new Msg(0, [arg]));
                    },
                    TestId: "multi-update-state-test-id",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "date")),
                    Value: unwrap(props.SelectedDate),
                })) : (empty_1())), delay(() => append(singleton(createElement(TextArea, {
                    ComponentState: componentState,
                    Label: t("general.comment"),
                    OnChange: (arg_1) => {
                        props.Dispatch(new Msg(1, [arg_1]));
                    },
                    TestId: "multi-update-state-test-id",
                    Value: props.Dto.Comment,
                })), delay(() => {
                    let elems, Label_3;
                    return singleton(reactElement("div", createObj(singleton_1((elems = [createElement(Button, (Label_3 = t("general.save"), {
                        ComponentState: (componentState === "disabled") ? "disabled" : ((isEmpty(props.TableElements) ? true : (props.Target == null)) ? "disabled" : "enabled"),
                        Label: Label_3,
                        OnClick: () => {
                            props.Dispatch(new Msg(4, []));
                        },
                        TestId: "multiple-switch-storage-save-button",
                        Variant: "primary",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems))])))));
                }))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Content(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "flex", "flex-col", "flex-1"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1"])], (elems = [createElement(Table, {
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            IsAddedElementTabVisible: isAddedElementsTabSelected,
            RemovedElements: props.RemovedElements,
            SetIsAddedElementTabVisible: patternInput_1[1],
            TableElements: props.TableElements,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (isAddedElementsTabSelected ? singleton(createElement(Form, {
            AccountSettings: props.AccountSettings,
            Definitions: props.Definitions,
            Dispatch: props.Dispatch,
            Dto: props.Dto,
            FormState: props.FormState,
            SelectedDate: unwrap(props.SelectedDate),
            TableElements: props.TableElements,
            Target: unwrap(props.Target),
        })) : empty_1())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function MultiUpdateStateModalSheet(props) {
    let elems, matchValue_2;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.UserData, props.ToolProps), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const patternInput_1 = useTranslation();
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue_2 = state_1.Definitions, (state_1.Sets.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((state_1.Tools.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_2.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            AccountSettings: props.AccountSettings,
            Definitions: matchValue_2.fields[0],
            Dispatch: patternInput[1],
            Dto: state_1.Dto,
            FormState: state_1.FormState,
            RemovedElements: state_1.RemovedElements,
            SelectedDate: unwrap(state_1.SelectedStateDate),
            TableElements: state_1.TableElements,
            Target: unwrap(state_1.Target),
        })))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput_1[0]("multi_operation.change_state.title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

